import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractInputComponent } from '@shared/form-elements/input/abstract-input/abstract-input.component';
import { ControlToKeyNamePipe } from '@shared/form-elements/pipes/control-to-key-name.pipe';
import { AutofocusDirective } from '@shared/autofocus/autofocus.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-input-basic',
    templateUrl: './input-basic.component.html',
    styleUrls: ['./input-basic.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgClass,
        NgIf,
        SvgIconComponent,
        FormsModule,
        ReactiveFormsModule,
        AutofocusDirective,
        ControlToKeyNamePipe
    ]
})
export class InputBasicComponent extends AbstractInputComponent {
    public focused = false;

    @Input()
    type: string = 'text';
    @Input()
    autocomplete: string = '';
    @Input()
    iconName: 'search' | '' = '';
    @Input()
    autoFocus: boolean = false;

    public onFocus(): void {
        this.focused = true;
        this.inputFocus.emit();
    }

    public onBlur(): void {
        this.focused = false;
        this.inputBlur.emit();
    }
}
